<template>
  <div id="preperation-page" class="preperation-page">
    <Header></Header>
    <div class="production-info">
      <ProductionInfo
        ref="productionInfo"
        v-if="ready"
        :workCenters="preperationWorkCenters"
        :preperation="true"
        :showingSuppliers="showingSuppliers"
        :allSuppliers="suppliers"
        @productSelected="showProduct"
        @hideProduct="hideProduct"
        @toProduction="openToProduction"
        @openDateChanger="openDateChanger"
      />
    </div>
    <div :style="previewStyle">
      <ProductPreview ref="productPreview"></ProductPreview>
    </div>
    <OrderOperationsMaker ref="orderOperationsMaker" @saved="productionSaved" />
    <DeliveryDateChanger ref="dateChanger" :suppliers="suppliers" :showingSuppliers="showingSuppliers" @saved="productionSaved" />
  </div>
</template>

<script>
import OrderOperationsMaker from "@/components/user/orders/OrderOperationsMaker.vue";
import DeliveryDateChanger from "@/components/production-planning/SupplierDeliveryDateChanger.vue";
import Header from "@/components/header.vue";
import ProductionInfo from "@/components/production-planning/ProductionInfo.vue";
import ProductPreview from "@/components/user/products/ProductPreview.vue";
import WorkCenter from "@/models/WorkCenter.js";
import Helper from "@/models/Helper.js";
import Supplier from "@/models/Supplier.js";
import User from "@/models/User.js";
export default {
  name: "preperation-page",
  data() {
    return {
      cursorPosition: null,
      workCenters: [],
      suppliers: [],
      showingSuppliers: [],
      ready: false,
      preperationWorkCenters: [],
      user: new User(this.$session.get("user")),
    };
  },
  computed: {
    previewStyle() {
      if (!this.cursorPosition) return;
      return {
        "z-index": 1000,
        position: "fixed",
        top: this.cursorPosition.y + 10 + "px",
        left: this.cursorPosition.x + 10 + "px",
      };
    },
  },
  async created() {
    if (this.user.company_id == 9) {
      this.$session.destroy();
      this.$router.push("/login").catch(() => {});
    }
    document.addEventListener("mousemove", this.onMouseMove, false);
    const showingSuppliers = await Supplier.loadShowing();
    this.showingSuppliers = showingSuppliers.sort((a,b) => {
      return a.order_number - b.order_number;
    });
    this.suppliers = await Supplier.loadSuppliers();
    await this.loadCenters();
    this.updateWindow();
    this.ready = true;
  },
  methods: {
    async updateWindow() {
      // eslint-disable-next-line
      // while (true) {
      //   if (this.$refs.productionInfo) {
      //     this.$refs.productionInfo.initialize();
      //   }
      //   if (this.$refs.productionHistory) {
      //     this.$refs.productionHistory.initialize();
      //   }
      //   await Helper.timeout(60000);
      // }
    },
    async loadCenters() {
      this.workCenters = await WorkCenter.loadCenters(
        false,
        this.hidePreperation
      );
      this.preperationWorkCenters = this.workCenters.filter((workCenter) => {
        if (workCenter.preperation) {
          return 1;
        }
        return 0;
      });
    },
    onMouseMove(e) {
      this.hideProduct();
      this.cursorPosition = {
        x: e.clientX,
        y: e.clientY,
      };
    },

    showProduct(product) {
      this.$refs.productPreview.showProduct(product);
    },

    hideProduct() {
      if (this.$refs.productPreview) {
        this.$refs.productPreview.hideProduct();
      }
    },
    openToProduction(selected) {
      if (this.$refs.orderOperationsMaker) {
        this.$refs.orderOperationsMaker.open(selected);
      }
    },
    openDateChanger(order, suppliers){
      if(this.$refs.dateChanger){
        this.$refs.dateChanger.open(order, suppliers);
      }
    },
    productionSaved(){
      if(this.$refs.productionInfo){
        this.$refs.productionInfo.updateScreen();
      }
    }
  },
  components: {
    OrderOperationsMaker,
    Header,
    ProductionInfo,
    ProductPreview,
    DeliveryDateChanger
  },
};
</script>

<style scoped>
.planning-page {
  position: absolute;
  width: 100%;
  height: 100%;
}
.production-info {
  position: relative;
  height: calc(100% - 100px);
  overflow-y: auto;
}
.production-info::-webkit-scrollbar {
  width: 10px;
}
.production-info::-webkit-scrollbar-track {
  background: #f1f1f1;
}
.production-info::-webkit-scrollbar-thumb {
  background: rgba(117, 121, 129, 0.952);
}
</style>